const brand = 'singleton'

module.exports = {
  brand,
  title: '以時間慢淬的美好<br/>小廢墟創辦人的<br class="mobile-only" />斜槓人生',
  brief: '小廢墟Ruins Coffee Roasters是一間位於木柵的咖啡館，在創辦人洪璽開改造以前，是一間木工和水電的倉庫，洪璽開會木工、烘豆，同時也是咖啡師、staycool樂團主唱與吉他手，具多元斜槓身分的他，更是威士忌的愛好者。',
  article: [
    {
      type: 'youtube',
      content: {
        youtubeId: '-mEYv-7808I',
        description: '洪璽開對喜歡的事從不馬虎，願意花時間追尋心中想望，就像蘇格登「以時間慢淬最好」的理念。'
      }
    },
    {
      type: 'heading',
      content: '改建廢墟成咖啡館　用心打造的美好'
    },
    {
      content: '五年前，洪璽開第一次看到小廢墟，那是一個廢棄了二十年的倉庫，當他決心親自改造這個空間時，心裡支持著他的信念是「心難事就難，心不難事就容易了！」儘管如此，要將廢墟改造整理成一間咖啡館，要花的時間和精力還是遠比想像中來的多，但洪璽開說：「對我來說一個花時間去完成的東西是不一樣的，你花三年五年慢慢思考，然後去醞釀出來的東西，它沒有辦法被短時間的東西給取代」。'
    },
    {
      content: '在這快速變遷、事事講求效率的年代，「時間」成了最珍貴的資產，而蘇格登為釀造豐富醇順的單一麥芽威士忌，不惜以長時間發酵、緩慢蒸餾，加上曠時熟成，以慢工藝打造萬千風味的威士忌，「以時間慢淬最好」的理念，和洪璽開的生活態度不謀而合。'
    },
    {
      type: 'image',
      content: {
        url: `${brand}/image-01.jpg`,
        description: '小廢墟咖啡Ruins Coffee Roasters原本是個廢棄20年的倉庫，經洪璽開近半年的改造後，才有了現在的樣子。'
      }
    },
    {
      type: 'heading',
      content: '蘇格登15年溫順厚實　12年醇雪莉甜而不膩'
    },
    {
      content: '現在的小廢墟有洪璽開的姊姊、夥伴幫忙經營，大部分的時間洪璽開都在烘豆，很少站吧台顧店，但每天早上他都還是會沖杯咖啡給自己，晚上則會和老婆一起喝杯威士忌，作為一天結束前的重要儀式。'
    },
    {
      content: '有著圓潤滑順，以及豐富層次的蘇格登15年單一麥芽威士忌，適合搭配各種餐點，對洪璽開來說，就像一支帶有花香的瓜地馬拉，其中宜人的木質香調和清新果香，喝起來溫順厚實也帶點優雅。'
    },
    {
      content: '而蘇格登12年單一麥芽威士忌–醇雪莉版，洪璽開說老婆特別喜歡，蘇格登以獨創的「三桶新工藝」，加入少見的歐洲橡木訂製雪莉桶，提昇酒體中濃厚的雪莉口感，「我覺得它像是一支日曬的衣索比亞，適合當作餐後甜點酒」洪璽開說。'
    },
    {
      type: 'image',
      content: {
        url: `${brand}/image-02.jpg`,
        description: '洪璽開與老婆分別偏好蘇格登15年與蘇格登12年醇雪莉版。'
      }
    },
    {
      type: 'heading',
      content: '盡情探索勇敢嘗試　蘇格登伴你追夢'
    },
    {
      content: '蘇格登不僅適合在日常生活中品飲，更是聚會場合上不可或缺的酒款，蘇格登以慢工藝著稱，從不催促、不安於現狀，就像小廢墟創辦人洪璽開一樣，保持好奇心和不斷探索的熱情，勇敢追夢、創造豐富充實的生活。'
    },
    {
      type: 'image',
      content: {
        url: `${brand}/image-03.jpg`,
        description: '蘇格登15年單一麥芽威士忌富含瓜果花香與清新的柑橘香氣。'
      }
    },
  ],
  unitId: 'mirror_RWD_Singleton_970250-300250_FT'
}
